export default __webpack_public_path__ + "4971f359279a1f1464e7b74bc7fc666a.png";